/** Tiny seeded PRNG (mulberry32). Visual-only: keeps procedural details stable between reloads. */
export type Rng = () => number;

export const mulberry32 = (seed: number): Rng => {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

/** Centered noise in [-0.5, 0.5). */
export const centered = (rng: Rng): (() => number) => () => rng() - 0.5;
